let setTrips = (state, trips) => {
	state.trips = trips;
};

export default { setTrips };
